import * as React from 'react';
import {AcceptorsFilterViewBaseProps} from '../../model';
import View from './view';

export const AcceptorsFilterVisuallyImpaired: React.FC<AcceptorsFilterViewBaseProps> = (props) => {
  return <View {...props} />;
};
